let prefix = '/api/control/voucher';

function index() {
    return window.axios.get(prefix + '/index');
}
function getVoucherInfo(data) {
    return window.axios.post(prefix + '/info/voucher', data);
}
function getUniqueVoucherInfo(data) {
    return window.axios.post(prefix + '/info/voucher/unique', data);
}
function getBatchBasicInfo(data) {
    return window.axios.post(prefix + '/info/batch/basic', data);
}
function getAuthInfo(data) {
    return window.axios.post(prefix + '/info/auth', data);
}
function updateApproval(data) {
    return window.axios.post(prefix + '/update/approval', data);
}
function getVoucherStatusList(){
    return window.axios.get(prefix + '/list/status');
}
function getLinesStatus() {
    return window.axios.get(prefix + '/list/returnTypes');
}
function getFilterGeneral(data) {
    return window.axios.post(prefix + '/filter/general', data);    
}
function getCostData(data) {
    return window.axios.get(prefix + '/index/data/cost', data);
}
function getCostInfoByDestiny(data) {
    return window.axios.post(prefix + '/cost/destiny', data);
}
export default {
    index, getVoucherInfo, getUniqueVoucherInfo, getBatchBasicInfo, getAuthInfo, updateApproval, getVoucherStatusList, getLinesStatus, getFilterGeneral, getCostData, getCostInfoByDestiny,

}